/**
 * Filter negative values
 * @param  {Number} value The value to Filter
 * @return {Boolean} true if value is negative, false otherwise
 */
export default function (value) {
  return value < 0;
}
